import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { inr } from "@/lib/api";

const ProductCard = ({ product, index = 0 }) => (
  <motion.div
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay: (index % 3) * 0.08 }}
    data-testid={`product-card-${product.id}`}
  >
    <Link to={`/product/${product.id}`} className="group block">
      <div className="relative overflow-hidden bg-[#F2EFE9] aspect-[4/5]">
        <img
          src={product.images?.[0]}
          alt={product.name}
          className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.05]"
        />
        <span className="absolute top-4 left-4 font-mono text-[9px] uppercase tracking-[0.2em] bg-[#F9F8F6] text-[#1A1A1A] px-2.5 py-1">
          {product.category}
        </span>
      </div>
      <div className="pt-4 flex items-start justify-between gap-4">
        <div>
          <h3 className="font-serif text-xl md:text-2xl leading-tight text-[#1A1A1A] group-hover:text-[#8C3A3A] transition-colors duration-300">
            {product.name}
          </h3>
          <p className="font-mono text-[10px] uppercase tracking-[0.18em] text-[#595959] mt-1">{product.fabric}</p>
        </div>
        <p data-testid="product-price" className="font-mono text-sm text-[#1A1A1A] whitespace-nowrap mt-1">{inr(product.price)}</p>
      </div>
    </Link>
  </motion.div>
);

export default ProductCard;
